/**
 * チャットボタンUX（スマホ専用）
 *
 * - ボタン表示時: zoom 0.75 で縮小
 * - チャットを開く: zoom 解除→フルサイズ表示
 * - スクロールしたら: zoom 0.75 に戻す
 */
(function () {
  "use strict";

  var MOBILE_MAX = 1079;

  var SELECTORS = [
    "#ch-plugin",
    "shulex-chatbot-lancher",
    "shulex-chatbot-launcher",
  ];

  var chatOpen = false;
  var found = false;

  function mobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function getEls() {
    var result = [];
    for (var i = 0; i < SELECTORS.length; i++) {
      var el = document.querySelector(SELECTORS[i]);
      if (el) result.push(el);
    }
    return result;
  }

  function applyState() {
    if (!mobile()) {
      document.body.classList.remove("chat-open");
      return;
    }
    if (chatOpen) {
      document.body.classList.add("chat-open");
    } else {
      document.body.classList.remove("chat-open");
    }
  }

  function onScroll() {
    if (!mobile()) return;
    if (chatOpen) {
      chatOpen = false;
      applyState();
    }
  }

  function onChatClick() {
    if (!mobile()) return;
    chatOpen = true;
    applyState();
  }

  function bindClickListeners() {
    var list = getEls();
    for (var i = 0; i < list.length; i++) {
      if (list[i].dataset.chatUxBound) continue;
      list[i].dataset.chatUxBound = "1";
      list[i].addEventListener("click", onChatClick, true);
    }
  }

  function tryInit() {
    if (!mobile()) return;
    var list = getEls();
    if (list.length === 0) return;
    found = true;
    bindClickListeners();
    applyState();
  }

  function start() {
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", applyState);

    tryInit();

    var poll = setInterval(function () {
      tryInit();
      if (found) clearInterval(poll);
    }, 400);
    setTimeout(function () { clearInterval(poll); }, 16000);

    if (typeof MutationObserver !== "undefined" && document.body) {
      var timer;
      new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(tryInit, 80);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
